import LanguagePicker from './LanguagePicker';

export default LanguagePicker;
